import React from 'react';
import styled from 'styled-components';

import {StyledPageCenterContainer, pxToEm} from '../../components/globalStyles';
import HexagonIconImage from '../../components/hexagonIconImage';
import Layout from '../../components/layout/layout';
import PageViewHeadline from '../../components/pageViewHeadline';
import AboutUsSvg from '../../media/hexagonIconImage/icons/about_us.svg';

import PeopleSaySection from './peopleSaySection';
import ProductOverviewSection from './productOverviewSection';
import WorldwideCustomersSection from './worldwideCustomersSection';
import WorldwideTeamSection from './worldwideTeamSection';

const StyledAboutUsPageCenterContainer = styled(StyledPageCenterContainer)`
  padding-top: ${pxToEm(124)}em;
  padding-bottom: ${pxToEm(124)}em;

  > *:not(:last-child) {
    margin-bottom: ${pxToEm(100)}em;
  }
`;

const AboutUsPageView: React.FunctionComponent = () => (
  <Layout>
    <PageViewHeadline
      topSubHeadline={'About Us'}
      headline={'Bitmovin - shaping the future of video'}
      badgeComponent={<HexagonIconImage iconSrc={AboutUsSvg} />}
    />
    <StyledAboutUsPageCenterContainer>
      <WorldwideTeamSection />
      <WorldwideCustomersSection />
      <PeopleSaySection />
      <ProductOverviewSection />
    </StyledAboutUsPageCenterContainer>
  </Layout>
);

export default AboutUsPageView;
